import dayjs from 'dayjs';
import { TimePicker } from 'antd';
import { LESSON_NUMBERS } from 'features/schedule/model/constants';
import { USER_TIME_FORMAT } from 'shared/constants/date';
import type { Bell } from 'services/api';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';

export const getColumns = (
  readOnly?: boolean,
  onTimeChange?: (index: number, field: 'startTime' | 'endTime', value: string) => void,
  getShiftRowSpan?: (index: number) => number,
  getShiftLabel?: (index: number) => string,
): AppTableColumn<Bell>[] => [
  {
    key: 'shift',
    title: 'Смена',
    dataIndex: ['shift'],
    minWidth: 160,
    onCell: (_record, index) => {
      if (index === undefined) {
        return {};
      }

      return {
        rowSpan: getShiftRowSpan?.(index) ?? 1,
      };
    },
    render: (_shift, _record, index) => {
      if (index === undefined) {
        return null;
      }

      const rowSpan = getShiftRowSpan?.(index) ?? 1;
      if (rowSpan === 0) {
        return null;
      }

      return getShiftLabel?.(index) ?? '';
    },
  },
  {
    key: 'lessonIndex',
    title: 'Урок',
    dataIndex: ['lessonIndex'],
    maxWidth: '5rem',
    render: (text) => {
      return `${LESSON_NUMBERS.indexOf(text) + 1}`;
    },
  },
  {
    key: 'startTime',
    title: 'Начало урока',
    dataIndex: ['startTime'],
    render: (text, _record, index) => {
      if (readOnly) return text;
      return (
        <TimePicker
          showNow={false}
          value={text ? dayjs(text, USER_TIME_FORMAT) : undefined}
          format={USER_TIME_FORMAT}
          onChange={(_time, timeString) =>
            onTimeChange?.(
              index,
              'startTime',
              Array.isArray(timeString) ? timeString[0] : timeString,
            )
          }
        />
      );
    },
  },
  {
    key: 'endTime',
    title: 'Конец урока',
    dataIndex: ['endTime'],
    render: (text, _record, index) => {
      if (readOnly) return text;
      return (
        <TimePicker
          showNow={false}
          value={text ? dayjs(text, USER_TIME_FORMAT) : undefined}
          format={USER_TIME_FORMAT}
          onChange={(_time, timeString) =>
            onTimeChange?.(index, 'endTime', Array.isArray(timeString) ? timeString[0] : timeString)
          }
        />
      );
    },
  },
];
